export const ROLE_USER_CONSTANT = Object.freeze({
    SUPER_ADMIN: "super_admin",
    CS_LEAD: "cs_lead",
    OPERATOR: "operator",
    CUSTOMER_SERVICE: "cso",
    DATA_VALIDATOR: "data_validator",
    CS_MANAGER: "cs_manager",
    CS_COORDINATOR: "cs_coordinator",
    BUG_VALIDATOR: "bug_validator",
    DISTRIBUTOR: "customer",
    PRINCIPAL: "principal",
});